module.exports = __webpack_public_path__ + "img/social_media-twitter.0fbf5107.svg";